<template>
  <el-dialog
    :visible.sync="model"  
    class="slid-dialog"
    :style="{
      width: width,
    }"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="slid-title" v-if="title">
      <slot name="slid-title-left" />
      <p>{{title}}</p>
      <fps-icon class="close-icon" type="close" @click.native="closeDialog" />
    </div>
    <slot name="slid-content" />
  </el-dialog>
</template>

<script>
export default {
  props: {
    model:{
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default:'411px',
    },
    title: {
      type: String,
      default: '',
    },
    confirmBtn: {
      type: String,
      default: '',
    },
    cancelBtn: {
      type: String,
      default: '',
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    }
  }

}
</script>

<style lang="scss" scoped>
.slid-dialog {
  font-size: 16px;
  padding: 0px;
  .slid-title {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 61px;
    padding: 0 20px;
    border-bottom: 1px solid #ECECEC;
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 61px;
      color: #000000;
    }
    .close-icon {
      font-size: 18px;
      color: $color-gray-3;
    }
  }
  .slid-footer {
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .confirm-btn, .cancel-btn{
      width: 100px;
      height: 40px;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
    }
    .confirm-btn {
      color: #FFFFFF;
      background: linear-gradient(151.16deg, #FF4417 2.04%, #FB006E 60.91%);
    }
    .cancel-btn {
      background: #FFFFFF;
      color: black;
    }
  }
}
@media screen and (max-width: 599px){
  .slid-dialog {
    width: 100vw !important;
  }
}
</style>
<style lang="scss">
.el-dialog__wrapper.slid-dialog{
  margin: 0 auto;
  .el-dialog{
    width: 100%;
  }
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
  }
}
</style>